import { render, staticRenderFns } from "./indexDisplay.vue?vue&type=template&id=48835f52&scoped=true"
import script from "./indexDisplay.vue?vue&type=script&lang=js"
export * from "./indexDisplay.vue?vue&type=script&lang=js"
import style0 from "./indexDisplay.vue?vue&type=style&index=0&id=48835f52&lang=sass"
import style1 from "./indexDisplay.vue?vue&type=style&index=1&id=48835f52&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48835f52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48835f52')) {
      api.createRecord('48835f52', component.options)
    } else {
      api.reload('48835f52', component.options)
    }
    module.hot.accept("./indexDisplay.vue?vue&type=template&id=48835f52&scoped=true", function () {
      api.rerender('48835f52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/main/indexDisplay.vue"
export default component.exports